function getFeatureFlag(flags, key) {
  return flags.find(ff => ff.key === key);
}

function getTestGroup(groups, testName) {
  return groups.find(tg => tg.test_name === testName);
}

function trackTestGroup(testGroup, dataLayer) {
  dataLayer.push({
    event: 'abtests',
    slot: testGroup.test_segment_id,
    slot_value: `${testGroup.test_name}:${testGroup.test_group}`,
  });
}

class AnalyticsClient {
  trackEvent(eventData) {
    window.dataLayer.push({
      ...eventData,
      event: 'setapp',
    });
  }

  trackPageView(title, url) {
    window.dataLayer.push({
      event: 'virtualPageView',
      page: {
        title,
        url,
      },
    });
  }

  trackTestGroup(key) {
    const featureFlag = getFeatureFlag(this.featureFlags, key);

    if (featureFlag === undefined) {
      return;
    }

    if (!featureFlag.test_name) {
      return;
    }

    const testGroup = getTestGroup(this.testGroups, featureFlag.test_name);

    if (testGroup === undefined) {
      return;
    }

    trackTestGroup(testGroup, window.dataLayer);
  }

  setTestResults(featureFlags = [], testGroups = []) {
    this.featureFlags = featureFlags;
    this.testGroups = testGroups;
  }
}

export default AnalyticsClient;
